import React, { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from '../../store'
import { setUserRoleAction } from '../../store/auth/slice'
import { chooseProjectAction } from '../../store/project/slice'
import { getProjectUsersByRoleThunk } from '../../store/project/thunks';
import HeaderCreation from '../../components/PostCreation/Header'

interface MainProps {}

const PreviewPosts: FC<MainProps> = ({ children }) => {

  const dispatch = useDispatch()
  const [firstProjectLoaded, setFirstProjectLoaded] = useState<boolean>(false)

  const { currentProject, location, projects } = useSelector((state) => ({
    currentProject: state.project.currentProject,
    location: state.router.location,
    projects: state.agency.projects
  }))

  useEffect(() => {
    const getProjectId = async ()=>{
      if (!firstProjectLoaded) {
        const currentProjectId = +location.pathname.split('/')[1]
        const currentProjectAfterLoadPage = projects.find(({ id }) => id === currentProjectId)
        if (currentProjectAfterLoadPage && currentProjectAfterLoadPage.id !== currentProject.id) {
          setFirstProjectLoaded(true)
          await dispatch(setUserRoleAction(currentProjectAfterLoadPage.role))
          await dispatch(chooseProjectAction(currentProjectAfterLoadPage))
          await dispatch(getProjectUsersByRoleThunk())
        }
      }
    }
     getProjectId();
  }, [projects])

  return (
    <div className='posts-creation'>
      <div className='posts-creation__header'>
        <HeaderCreation />
      </div>
      <div className='posts-creation__content'>{children}</div>
    </div>
  )
}

export default PreviewPosts
